<template>
  <div class="flex justify-center items-center h-screen">
    <div class="text-center">
      <p class="text-2xl mb-4">Seite nicht gefunden</p>
      <NuxtLink to="/" class="button">Zurück zur Startseite</NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
useHead({
	title: "Circus St. Ottilien • Seite nicht gefunden",
});
</script>
